"use client";

import { ChevronDown } from "lucide-react";
import { Accordion, AccordionDetails, AccordionSummary, Box, colors, Grid2 as Grid, Typography } from "@mui/material";
import { Theme, useTheme } from "@mui/material/styles";
import { Fragment } from "react";

type FaqItem = {
    id: number;
    question: string;
    answer: string;
    default_open: boolean;
    show_in_site: boolean;
};

export default function HomepageFaq({ content }: { content: FaqItem[] | null }) {
    const theme = useTheme();
    const items = content?.filter(i => i.show_in_site) ?? [];
    if (!items.length) return <Fragment />;

    const isOdd = items.length % 2 === 1;

    return (
        <Box sx={{ px: { xs: 3, lg2: 0 } }}>
            <Typography
                component="h2"
                sx={{ fontSize: { xs: 22, md: 28 }, fontWeight: 700, mb: 3, color: colors.grey[900] }}
            >
                سوالات متداول
            </Typography>
            <Grid container spacing={{ xs: 0, md: 2 }}>
                {items.map((item, index) => {
                    const isLast = index === items.length - 1;
                    return (
                        <Grid key={item.id} size={{ xs: 12, md: isOdd && isLast ? 12 : 6 }}>
                            <AccordionItem item={item} theme={theme} />
                        </Grid>
                    );
                })}
            </Grid>
        </Box>
    );
}

const AccordionItem = ({ item, theme }: { item: FaqItem; theme: Theme }) => (
    <Accordion
        defaultExpanded={item.default_open}
        elevation={0}
        sx={{
            '&::before': { opacity: '0 !important', height: 0 },
            margin: '0 !important',
            mb: 1,
            borderTop: '1px solid',
            borderColor: colors.grey[300],
            borderRadius: '0 !important',
        }}
    >
        <AccordionSummary
            expandIcon={<ChevronDown color={colors.grey[700]} />}
            sx={{ [theme.breakpoints.down('md')]: { padding: 0 } }}
        >
            <Typography sx={{ fontWeight: 500, color: colors.grey[900], fontSize: { xs: 13, md: 16 } }}>
                {item.question}
            </Typography>
        </AccordionSummary>
        <AccordionDetails sx={{ [theme.breakpoints.down('md')]: { padding: 0 } }}>
            <Typography
                component="div"
                sx={{
                    fontSize: { xs: 12, md: 14 },
                    color: colors.grey[800],
                    lineHeight: '28px',
                    pb: 1,
                    '& p': { margin: 0 },
                    '& a': { color: colors.red[900], textDecoration: 'underline' },
                }}
                dangerouslySetInnerHTML={{ __html: item.answer }}
            />
        </AccordionDetails>
    </Accordion>
);
